<h2 class="si-sidebar-title">{{constants.inquiryTitle}}</h2>
<ul class="step-list">
  <li *ngFor="let step of constants.steps; let i = index">
    <span class="step-icon" [ngClass]="i < activeStep ? 'step-check' : 'step-uncheck'"></span>
    <span class="step-text" [ngClass]="{'current-step': i === activeStep}">{{step}}</span>
  </li>
</ul>
<p class="si-sidebar-required">(<span class="star-red">*</span>) {{constants.required}}</p>
